"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _header = _interopRequireDefault(require("../header"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Table = _interopRequireDefault(require("@insided/deprecated-preact-components/table/Table"));

var _LastActiveCell = _interopRequireDefault(require("./cells/LastActiveCell"));

var _UserCell = _interopRequireDefault(require("./cells/UserCell"));

var _RoleCell = _interopRequireDefault(require("./cells/RoleCell"));

var _ActionCell = _interopRequireDefault(require("./cells/ActionCell"));

var _InviteUserModal = _interopRequireDefault(require("./InviteUserModal"));

var _InviteUserWarningModal = _interopRequireDefault(require("./InviteUserWarningModal"));

var _CancelInviteModal = _interopRequireDefault(require("./CancelInviteModal"));

var _Loader = _interopRequireDefault(require("../ui-components/Loader"));

var _seatsService = require("@insided/deprecated-control/services/seatsService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TeamOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TeamOverview, _Component);

  var _super = _createSuper(TeamOverview);

  function TeamOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TeamOverview);
    _this = _super.call(this, props);
    _this.state = {
      limit: 0,
      users: [],
      current: 0,
      roles: [],
      messageType: null,
      message: '',
      sort: {
        order: 'lastActive',
        direction: 'desc'
      },
      inviteeEmail: null,
      selectedRole: null,
      inviteToCancel: null,
      showInviteUserModal: false,
      showInviteUserWarningModal: false,
      showCancelInvitationModal: false,
      isLoading: true,
      inviteErrors: {
        email: null
      }
    };
    _this.getSeatsSettings = _this.getSeatsSettings.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInviteUser = _this.onInviteUser.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelInvitation = _this.onCancelInvitation.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleInviteUserModal = _this.toggleInviteUserModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleInviteUserWarningModal = _this.toggleInviteUserWarningModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleCancelInvitationModal = _this.toggleCancelInvitationModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetAlert = _this.resetAlert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TeamOverview, [{
    key: "getSeatsSettings",
    value: function () {
      var _getSeatsSettings = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _roles$filter;

        var response, _response$data, limit, users, current, roles;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _seatsService.seatsService.getData();

              case 2:
                response = _context.sent;
                _response$data = response.data, limit = _response$data.limit, users = _response$data.users, current = _response$data.current, roles = _response$data.roles;
                this.setState({
                  limit: limit,
                  users: users,
                  current: current,
                  roles: roles,
                  selectedRole: (_roles$filter = roles.filter(function (role) {
                    return role.name === 'Community Manager';
                  })) === null || _roles$filter === void 0 ? void 0 : _roles$filter[0]
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSeatsSettings() {
        return _getSeatsSettings.apply(this, arguments);
      }

      return getSeatsSettings;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.getSeatsSettings();

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  messageType: 'error',
                  message: 'Something went wrong'
                });
                throw _context2.t0;

              case 9:
                _context2.prev = 9;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(9);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5, 9, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "onInviteUser",
    value: function () {
      var _onInviteUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this2 = this;

        var _this$state, inviteeEmail, selectedRole, _e$response, status, data;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _this$state = this.state, inviteeEmail = _this$state.inviteeEmail, selectedRole = _this$state.selectedRole;
                _context4.next = 4;
                return _axios.default.post('team/invite', {
                  email: inviteeEmail,
                  roleId: selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.id
                });

              case 4:
                this.setState({
                  showInviteUserModal: false,
                  messageType: 'success',
                  message: 'Invitation sent successfully'
                }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", _this2.getSeatsSettings());

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
                _context4.next = 12;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                _e$response = _context4.t0.response, status = _e$response.status, data = _e$response.data;

                if (status !== 500) {
                  this.setState({
                    inviteErrors: {
                      email: data
                    }
                  });
                } else {
                  this.setState({
                    messageType: 'error',
                    message: 'Something went wrong'
                  });
                }

                throw _context4.t0;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function onInviteUser() {
        return _onInviteUser.apply(this, arguments);
      }

      return onInviteUser;
    }()
  }, {
    key: "onCancelInvitation",
    value: function () {
      var _onCancelInvitation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this3 = this;

        var inviteToCancel;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                inviteToCancel = this.state.inviteToCancel;
                _context6.next = 4;
                return _axios.default.post('/team/cancelInvite', {
                  inviteId: inviteToCancel
                });

              case 4:
                this.setState({
                  showCancelInvitationModal: false,
                  messageType: 'success',
                  message: 'Your invitation has been successfully cancelled'
                }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
                  return _regenerator.default.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          return _context5.abrupt("return", _this3.getSeatsSettings());

                        case 1:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })));
                _context6.next = 11;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                this.setState({
                  messageType: 'error',
                  message: 'Something went wrong'
                });
                throw _context6.t0;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function onCancelInvitation() {
        return _onCancelInvitation.apply(this, arguments);
      }

      return onCancelInvitation;
    }()
  }, {
    key: "toggleInviteUserModal",
    value: function toggleInviteUserModal() {
      this.setState({
        showInviteUserModal: !this.state.showInviteUserModal,
        showInviteUserWarningModal: false,
        inviteeEmail: null,
        inviteErrors: {
          email: null
        }
      });
    }
  }, {
    key: "toggleCancelInvitationModal",
    value: function toggleCancelInvitationModal() {
      var inviteToCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.setState({
        inviteToCancel: inviteToCancel,
        showCancelInvitationModal: !this.state.showCancelInvitationModal
      });
    }
  }, {
    key: "toggleInviteUserWarningModal",
    value: function toggleInviteUserWarningModal() {
      this.setState({
        showInviteUserWarningModal: !this.state.showInviteUserWarningModal
      });
    }
  }, {
    key: "getTableModel",
    value: function getTableModel() {
      return [{
        header: 'Team member',
        accessor: 'team_member',
        cell: (0, _UserCell.default)()
      }, {
        header: 'Role',
        accessor: 'role',
        cell: (0, _RoleCell.default)()
      }, {
        header: 'Last active',
        accessor: 'last_active',
        cell: (0, _LastActiveCell.default)()
      }, {
        header: 'Action',
        accessor: 'action',
        cell: (0, _ActionCell.default)(this.toggleCancelInvitationModal)
      }];
    }
  }, {
    key: "resetAlert",
    value: function resetAlert() {
      this.setState({
        messageType: null,
        message: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          limit = _this$state2.limit,
          users = _this$state2.users,
          current = _this$state2.current,
          roles = _this$state2.roles,
          messageType = _this$state2.messageType,
          message = _this$state2.message,
          sort = _this$state2.sort,
          selectedRole = _this$state2.selectedRole,
          inviteeEmail = _this$state2.inviteeEmail,
          showInviteUserModal = _this$state2.showInviteUserModal,
          showInviteUserWarningModal = _this$state2.showInviteUserWarningModal,
          showCancelInvitationModal = _this$state2.showCancelInvitationModal,
          inviteErrors = _this$state2.inviteErrors;
      if (isLoading) return (0, _preact.h)(_Loader.default, null);
      var isUnlimited = limit === 0;
      var limitExceeded = current > limit;
      var limitEqualToCurrent = current === limit;
      return (0, _preact.h)("div", {
        className: "team-overview-page"
      }, (0, _preact.h)(_header.default, {
        title: "Team Overview",
        disableCancelButton: true,
        disableSaveButton: true,
        customButtons: roles !== null && roles !== void 0 && roles.length ? [{
          variant: 'primary',
          title: 'Invite member',
          action: (limitEqualToCurrent || limitExceeded) && !isUnlimited ? this.toggleInviteUserWarningModal : this.toggleInviteUserModal
        }] : []
      }), messageType && (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        isVisibleFor: 5000,
        onTimeoutEnd: this.resetAlert,
        onClose: this.resetAlert
      }), (0, _preact.h)("div", {
        className: "admin-seats-usage"
      }, (0, _preact.h)("div", {
        className: "number-of-members"
      }, current, " ", current === 1 ? 'Member' : 'Members', ' ', (0, _preact.h)("a", {
        className: "explanation",
        target: "__blank",
        href: "https://communities.gainsight.com/general-information-26/who-counts-as-a-team-member-seat-in-control-19068"
      }, "(Who counts as a team member?)")), !isUnlimited && (0, _preact.h)("div", {
        className: "number-of-seats"
      }, ' ', current, " out of ", limit, " seats assigned", ' ')), (0, _preact.h)("div", {
        className: "team-overview"
      }, (0, _preact.h)(_Table.default, {
        model: this.getTableModel(),
        rows: users !== null && users !== void 0 ? users : [],
        rowId: "id",
        sort: sort
      })), (0, _preact.h)(_InviteUserModal.default, {
        isOpen: showInviteUserModal,
        roles: roles,
        inviteeEmail: inviteeEmail,
        selectedRole: selectedRole,
        onEmailChange: function onEmailChange(inviteeEmail) {
          return _this4.setState({
            inviteeEmail: inviteeEmail
          });
        },
        onRoleChange: function onRoleChange(selectedRole) {
          return _this4.setState({
            selectedRole: selectedRole
          });
        },
        onInviteUser: this.onInviteUser,
        onClose: this.toggleInviteUserModal,
        errors: inviteErrors
      }), (0, _preact.h)(_InviteUserWarningModal.default, {
        limitEqualToCurrent: limitEqualToCurrent,
        isOpen: showInviteUserWarningModal,
        onContinueInviting: this.toggleInviteUserModal,
        onClose: this.toggleInviteUserWarningModal
      }), (0, _preact.h)(_CancelInviteModal.default, {
        isOpen: showCancelInvitationModal,
        onCancelInvitation: this.onCancelInvitation,
        onClose: this.toggleCancelInvitationModal
      }));
    }
  }]);
  return TeamOverview;
}(_preact.Component);

var _default = TeamOverview;
exports.default = _default;